export function getCookie( name ) {
  const value = `; ${ document.cookie }`;
  const parts = value.split( `; ${ name }=` );
  if ( parts.length === 2 ) return parts.pop().split( ';' ).shift();
  return null;
}

export function setCookie( name, value, days = 365, path = '/' ) {
  const date = new Date();
  date.setTime( date.getTime() + (days * 24 * 60 * 60 * 1000) );
  const expires = `expires=${ date.toUTCString() }`;
  document.cookie = `${ name }=${ value }; ${ expires }; path=${ path }`;
}

export function deleteCookie( name, path = '/' ) {
  document.cookie = `${ name }=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${ path }`;
}
